import axios from "axios";

const buscarEntidadeOrgaoUF = async function (endereco) {
  let resOrgaoEntidades = {}

  console.log("endereco", endereco)

  console.log("entrou buscarEntidadeOrgaoUF")
  try {
    const response = await axios({
        method: 'get',
        url: process.env.VUE_APP_ALIANCAADM + `/alianca/orgao-e-entidade/buscaGrpCobUf/${endereco}?api-key=` + process.env.VUE_APP_ALIANCAADM_ORGAO_ENTIDADE_API_KEY
      })

      const orgaoEntidades = response.data;

      const result = [...new Set(orgaoEntidades.map(x => x.BQC_GRPCOB))].map( x => {
      return{
        grupoCobranca: x,
        tipoorgaoentidade: orgaoEntidades.find(d => d.BQC_GRPCOB == x).BQC_XTPORG,
        descricao: orgaoEntidades.find(d => d.BQC_GRPCOB == x).BR0_DESCRI,
        nomeCompleto: orgaoEntidades.find(d => d.BQC_GRPCOB == x).BR0_NCOMPL,
        uf: orgaoEntidades.find(d => d.BQC_GRPCOB == x).BTN_UF,
        subFaturas : orgaoEntidades.filter(d => d.BQC_GRPCOB == x).map((u) => {
          if (u.BQC_SUBFAT) {
            const codSubfat = u.BQC_SUBFAT
            return codSubfat
          }
        }),
      }
      })

      resOrgaoEntidades = result;
  
  } catch (e) {
    console.log(e)
  }

  return resOrgaoEntidades
};

export default buscarEntidadeOrgaoUF;